import { render, staticRenderFns } from "./fcInfomationDetail.vue?vue&type=template&id=a1736074"
import script from "./fcInfomationDetail.vue?vue&type=script&lang=js"
export * from "./fcInfomationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports